import { useState } from 'preact/hooks';
import { useMutation } from '@tanstack/react-query';
import { POST, POST_CLAIM_RESEND_REQUEST } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';

export const canResendRequest = (claim) =>
  claim?.claimStatus === 'TRANSPORTED' &&
  !!String(claim?.refCsId || '').trim() &&
  !!String(claim?.refJournalId || '').trim();

export const useResendRequest = ({ onSuccess }) => {
  const [target, setTarget] = useState(null);
  const mutation = useMutation({
    mutationFn: async ({ claimId, reason }) => {
      const response = await POST(POST_CLAIM_RESEND_REQUEST(), { claimId, reason });
      if (response?.success === false) throw new Error(response.message);
      return response;
    },
    onSuccess: () => {
      setTarget(null);
      openAlert({
        model: 'message',
        type: 'success',
        message: 'ส่งคำขอส่งซ้ำแล้ว รออนุมัติที่เมนู อนุมัติ > ส่งซ้ำ',
      });
      onSuccess?.();
    },
  });

  return {
    target,
    isPending: mutation.isPending,
    openRequest: (claim) => {
      if (canResendRequest(claim) && !mutation.isPending) setTarget(claim);
    },
    closeRequest: () => {
      if (!mutation.isPending) setTarget(null);
    },
    submitRequest: ({ reason }) => {
      const trimmed = reason.trim();
      if (target && trimmed && trimmed.length <= 250 && !mutation.isPending) {
        mutation.mutate({ claimId: target.claimId, reason: trimmed });
      }
    },
  };
};
